export enum TipsVariantEnum {
  INFO = 'info',
  WARNING = 'warning',
  DANGER = 'danger',
}
